import { render, staticRenderFns } from "./create-item.vue?vue&type=template&id=ccdd7a6c&scoped=true&"
import script from "./create-item.vue?vue&type=script&lang=js&"
export * from "./create-item.vue?vue&type=script&lang=js&"
import style0 from "./create-item.vue?vue&type=style&index=0&id=ccdd7a6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccdd7a6c",
  null
  
)

export default component.exports